///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useMonth } from "@datepicker-react/hooks";
import styled from "styled-components";
import Day from "./Day";

const MonthLabel = styled.div`
  text-align: center;
  margin: 0 0 8px;
  font-size: 14px;
  line-height: 16px;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
`;

const MonthContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 32px);
  justify-content: center;
  font-size: 12px;
`;

const WeekdayLabel = styled.div`
  text-align: center;
  font-size: 12px;
  color: #717171;
  margin-bottom: 4px;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
`;

const DaysContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 32px);
  justify-content: center;
`;

const weekdayLabelFormat = (date) => {
  const days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
  return days[date.getDay()];
};

const Month = ({ year, month, firstDayOfWeek }) => {
  const { days, weekdayLabels, monthLabel } = useMonth({
    year,
    month,
    firstDayOfWeek,
    weekdayLabelFormat,
  });

  return (
    <div>
      <MonthLabel>
        <strong data-testid="datepicker-month-label">{monthLabel}</strong>
      </MonthLabel>
      <MonthContainer>
        {weekdayLabels.map((dayLabel) => (
          <WeekdayLabel key={dayLabel}>{dayLabel}</WeekdayLabel>
        ))}
      </MonthContainer>
      <DaysContainer>
        {days.map((day, index) => {
          if (typeof day === "object") {
            return (
              <Day
                date={day.date}
                key={day.date.toString()}
                dayLabel={day.dayLabel}
              />
            );
          }

          return <div key={index} />;
        })}
      </DaysContainer>
    </div>
  );
};

export default Month;
